export default __webpack_public_path__ + "static/media/story flash cards.ac2ff221.jpg";